import ICampaign from './ICampaign';

//import IModelFloorPlan from "./IModelFloorPlan";

export default interface IRawCampaign {
    makeIds: Object;
    modelIds: Object;
    modelYears: Number[];
    states: Array<string> | undefined;
    zipCodes: Array<string> | undefined;
    zipCode: string | undefined;
    distance: string | null;
    registeredAfterDate: string | null;
    registeredBeforeDate: string | null;
    title: string;
    messageBody: string;
    url: string;
    createdDateTime: string | null;
    submittedDateTime: string | null;
    scheduledDateTime: string | null;
    submittingUser: string | undefined;
    id: string | undefined;
}

export class RawCampaign implements Object {
    makeIds: Object;
    modelIds: Object;
    modelYears: Number[];
    states: Array<string> | undefined;
    zipCodes: Array<string> | undefined;
    geoFenceZipCode: string | undefined;
    geoFenceStreetAddress: string | undefined;
    geoFenceCity: string | undefined;
    geoFenceState: string | undefined;
    geoFenceRadiusInMiles: number | undefined;
    geoFenceLongitude: number | undefined;
    geoFenceLatitude: number | undefined;
    registeredAfterDate: string | null;
    registeredBeforeDate: string | null;
    title: string;
    messageBody: string;
    url: string;
    createdDateTime: string | null;
    submittedDateTime: string | null;
    scheduledDateTime: string | null;
    submittingUser: string | undefined;
    id: string | undefined;

    vinTargetsOriginalFileName: string | undefined;
    vinTargetsDescription: string | undefined;
    vinTargetsClaimCheckIdentifier: string | undefined;
    bypassUserNotificationOptOut: boolean;

    constructor(c: ICampaign) {
        this.makeIds = RawCampaign.createDictionary("Id", "Name", c.makes);
        this.modelIds = RawCampaign.createDictionary("Id", "Name", c.models);
        this.modelYears = c.years;
        this.states = c.states?.map((state) => state.abbreviation);
        this.zipCodes = c.zipCodes?.trim() === "" ? [] : c.zipCodes?.trim().split(' ');
        this.geoFenceStreetAddress = c.geoFenceStreetAddress;
        this.geoFenceCity = c.geoFenceCity;
        this.geoFenceState = c.geoFenceState ? c.geoFenceState.abbreviation : '';
        this.geoFenceZipCode = c.geoFenceZipCode;
        this.geoFenceRadiusInMiles = c.geoFenceRadiusInMiles;
        this.geoFenceLatitude = c.geoFenceLatitude;
        this.geoFenceLongitude = c.geoFenceLongitude;
        this.registeredAfterDate = c.registeredAfterDate && c.registeredAfterDate.length > 0 ? c.registeredAfterDate : null;
        this.registeredBeforeDate = c.registeredBeforeDate && c.registeredBeforeDate.length > 0 ? c.registeredBeforeDate : null;
        this.title = c.title;
        this.messageBody = c.messageBody;
        this.url = c.url;
        this.createdDateTime = c.createdDateTime && c.createdDateTime.length > 0 ? c.createdDateTime : null;
        this.submittedDateTime = c.submittedDateTime && c.submittedDateTime.length > 0 ? c.submittedDateTime : null;
        this.scheduledDateTime = c.scheduledDateTime && c.scheduledDateTime.length > 0 ? c.scheduledDateTime : null;
        this.submittingUser = c.submittingUser;
        this.vinTargetsOriginalFileName = c.vinTargetsOriginalFileName;
        this.vinTargetsDescription = c.vinTargetsDescription;
        this.vinTargetsClaimCheckIdentifier = c.vinTargetsClaimCheckIdentifier;
        this.bypassUserNotificationOptOut = c.bypassUserNotificationOptOut;
        if (c.id) {
            this.id = c.id;
        }
    }

    public static createDictionary(keyField: string, valueField: string, objArray: any[]): any {
        const dictionary: any = {};
        if (objArray && keyField && valueField) {
            for (let i = 0; i < objArray.length; i++) {
                let item: any = objArray[i];
                dictionary[item[keyField]] = item[valueField];
            }
        }
        return dictionary;
    }

    public getObjectWithOnlyDefinedFields(): Object {
        let outputObj: any = {};
        for (let [key, value] of Object.entries(this)) {
            if (value !== null && value !== undefined) {
                outputObj[key] = value;
            }
        }
        return outputObj;
    }
}
